// 史诗
import { EquipMain } from "../equipmentType";
import { equipTypes } from "../equipConst";
import { propertyName, propertyAttr } from "@/const/character";
// 武器池
const equipPoolListW: EquipMain[] = [
  {
    name: "雷雷的牙齿",
    describe: "嗷呜！嗷呜~",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 90
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 30
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.4
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.1
      }
    ],
    grade: 5,
    level: 15,
    icon: 19,
    price: 2000
  },
  {
    name: "无嘤剑",
    describe: "无嘤剑你怕不怕",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 120
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.2
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.2
      },
      {
        name: propertyName.CRD,
        type: propertyAttr.CRD,
        isPercent: false,
        value: 0.3
      }
    ],
    grade: 5,
    level: 15,
    icon: 11,
    price: 2000
  }
];
// 防具池
const equipPoolListA: EquipMain[] = [
  {
    name: "猫妖王的毛皮",
    describe: "这皮草一定能卖个好价钱",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 333
      },
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 33
      },
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 33
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 33
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 33
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 33
      }
    ],
    grade: 5,
    level: 21,
    icon: 34,
    price: 900
  }
];
// 首饰池
const equipPoolListJ: EquipMain[] = [
  {
    name: "喵喵的符文项链",
    describe: "戴上它，就能成为猫王吗？喵？",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 2.5
      },
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: -60
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 150
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: -40
      }
    ],
    grade: 5,
    level: 21,
    icon: 40,
    price: 1500
  }
];

const equipsGrade5: EquipMain[] = [
  ...equipPoolListW,
  ...equipPoolListA,
  ...equipPoolListJ
];
export { equipsGrade5 };
